export function handleTree(data, id, parentId, children, rootId) {
  id = id || 'id'
  parentId = parentId || 'parentId'
  children = children || 'children'
  rootId = rootId || Math.min.apply(Math, data.map(item => { return item[parentId] })) || 0
  // 对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(data))
  // 循环所有项
  const treeData = cloneData.filter(father => {
    const branchArr = cloneData.filter(child => {
      // 返回每一项的子级数组
      return father[id] === child[parentId]
    })
    branchArr.length > 0 ? father.children = branchArr : ''
    // 返回第一层
    return father[parentId] === rootId
  })
  return treeData != '' ? treeData : data
}

// 回显数据字典
export function selectDictLabel(datas, value) {
  var actions = []
  Object.keys(datas).some((key) => {
    if (datas[key].dictValue == ('' + value)) {
      actions.push(datas[key].dictLabel)
      return true
    }
  })
  return actions.join('')
}

// 转换字符串，undefined,null等转化为""
export function praseStrEmpty(str) {
  if (!str || str == 'undefined' || str == 'null') {
    return ''
  }
  return str
}
// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/')
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

// number转为汉字大写
export function toChineseBig(money) {
  // 汉字的数字
  var cnNums = new Array('零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖')
  // 基本单位
  var cnIntRadice = new Array('', '拾', '佰', '仟')
  // 对应整数部分扩展单位
  var cnIntUnits = new Array('', '万', '亿', '兆')
  // 对应小数部分单位
  var cnDecUnits = new Array('角', '分', '毫', '厘')
  // 整数金额时后面跟的字符
  var cnInteger = '整'
  // 整型完以后的单位
  var cnIntLast = '元'
  // 最大处理的数字
  var maxNum = 999999999999999.9999
  // 金额整数部分
  var integerNum
  // 金额小数部分
  var decimalNum
  // 输出的中文金额字符串
  var chineseStr = ''
  // 分离金额后用的数组，预定义
  var parts
  // 传入的参数为空情况
  if (money == '') {
    return ''
  }
  money = parseFloat(money)
  if (money >= maxNum) {
    return ''
  }
  // 传入的参数为0情况
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger
    return chineseStr
  }
  // 转为字符串
  money = money.toString()
  // indexOf 检测某字符在字符串中首次出现的位置 返回索引值（从0 开始） -1 代表无
  if (money.indexOf('.') == -1) {
    integerNum = money
    decimalNum = ''
  } else {
    parts = money.split('.')
    integerNum = parts[0]
    decimalNum = parts[1].substr(0, 4)
  }
  // 转换整数部分
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0
    const IntLen = integerNum.length
    for (let i = 0; i < IntLen; i++) {
      const n = integerNum.substr(i, 1)
      const p = IntLen - i - 1
      const q = p / 4
      const m = p % 4
      if (n == '0') {
        zeroCount++
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0]
        }
        zeroCount = 0
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q]
      }
    }
    // 最后+ 元
    chineseStr += cnIntLast
  }
  // 转换小数部分
  if (decimalNum != '') {
    const decLen = decimalNum.length
    for (let i = 0; i < decLen; i++) {
      const n = decimalNum.substr(i, 1)
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i]
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger
  } else if (decimalNum == '') {
    chineseStr += cnInteger
  }

  return chineseStr
}
// 金额格式化获取
export function formaterMoney(data, type) {
  if (!data && data != 0) return ''
  if (data && data.toString().indexOf('.') > -1) {
    // if (!data && data!=0) return '.00'
    // 预定义小数部分
    let decimal = '.00'
    // 将数据分割，保留两位小数
    data = data.toFixed(2)
    const newArr = data.toString().split('.')
    if (newArr.length === 2) { // 有小数部分
      decimal = '.' + newArr[1].toString() // 取得小数部分
    }
    // 获取整数部分
    let intPart = Math.trunc(data)
    intPart = Math.abs(intPart)
    // 给整数每隔3位加,逗号
    intPart = (intPart || 0).toString()
    let result = ''
    while (intPart.length > 3) {
      result = ',' + intPart.slice(-3) + result
      intPart = intPart.slice(0, intPart.length - 3)
    }
    if (intPart) { result = intPart + result }
    if (data < 0) {
      return '-' + result + decimal
    } else {
      return result + decimal
    }
  } else {
    if (!data) return '0'
    // 将数据分割，保留两位小数
    data = data.toFixed(2)
    // 获取整数部分
    let intPart = Math.trunc(data)
    intPart = Math.abs(intPart)
    // 给整数每隔3位加,逗号
    intPart = (intPart || 0).toString()
    let result = ''
    while (intPart.length > 3) {
      result = ',' + intPart.slice(-3) + result
      intPart = intPart.slice(0, intPart.length - 3)
    }
    if (intPart) { result = intPart + result }
    if (data < 0) {
      return '-' + result + '.00'
    } else {
      return result + '.00'
    }
  }
  // // 返回整数部分
  // if (type == 0) {
  // 		if (!data) return '0'
  // 		// 将数据分割，保留两位小数
  // 		data = data.toFixed(2)
  // 		// 获取整数部分
  // 		let intPart = Math.trunc(data)
  // 		// 给整数每隔3位加,逗号
  // 		intPart = (intPart || 0).toString()
  // 		let result = ''
  // 		while (intPart.length > 3) {
  // 				result = ',' + intPart.slice(-3) + result
  // 				intPart = intPart.slice(0, intPart.length - 3)
  // 		}
  // 		if (intPart) { result = intPart + result }
  // 		return result
  // }
  // // 返回小数部分
  // if (type == 1) {
  // 		if (!data) return '.00'
  // 		// 预定义小数部分
  // 		let decimal = '.00'
  // 		// 将数据分割，保留两位小数
  // 		data = data.toFixed(2)
  // 		const newArr = data.toString().split('.')
  // 		if (newArr.length === 2) { // 有小数部分
  // 				decimal = '.' + newArr[1].toString() // 取得小数部分
  // 		}
  // 		return decimal
  // }
}

// JS 获取最后一个 指定字符  后面的值
export function getValue(url) {
  // 获取最后一个/的位置
  var site = url.lastIndexOf('\/')
  // 截取最后一个/后的值
  return url.substring(site + 1, url.length)
}
